/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import AppSnackbarItem from "./AppSnackbarItem";
import IAppSnackbarState from "./IAppSnackbarState";
import { isPathMatching, pathFrom } from "./pathHelpers";

export default function createAppSnackbarState(items: AppSnackbarItem[]): IAppSnackbarState {
    const byPath = (
        typBezeichnung: string | undefined,
        feldPfad: string | string[]
    ) => {
        return (item: AppSnackbarItem) => {
            return isPathMatching(item, pathFrom(typBezeichnung, feldPfad));
        }
    };

    const itemsToArray = (typBezeichnung: string, feldPfad: string | string[]): string[] => {
        return items
            .filter(byPath(typBezeichnung, feldPfad))
            .map((i) => i.message)
            .filter((message, index, messages) => messages.indexOf(message) === index);
    };

    const itemsToText = (typBezeichnung: string, feldPfad: string | string[]) => {
        return itemsToArray(typBezeichnung, feldPfad).join(" ");
    };

    const hasItems = (typBezeichnung: string | undefined, feldPfad: string | string[]) => {
        return items.some(byPath(typBezeichnung, feldPfad));
    };

    const findItem = (...path: string[]) => {
        return items.find(item => {
            for (let idx = 0; idx < path.length; idx++) {
                if (path[idx].toLowerCase() !== item.path[idx]?.toLowerCase()) {
                    return false;
                }
            }

            return true;
        });
    };

    return {
        hasItems,
        items,
        itemsToArray,
        itemsToText,
        findItem,
    };
}